module.exports = __webpack_public_path__ + "static/img/btn.e0c5983.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market105/btn.png
// module id = zkRH
// module chunks = 1